var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#1EC677"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.54 16.12L25.04 14.06C24.47 13.85 23.54 13.85 22.97 14.06L17.47 16.12C16.41 16.52 15.55 17.76 15.55 18.89V26.99C15.55 27.8 16.08 28.87 16.73 29.35L22.23 33.46C23.2 34.19 24.79 34.19 25.76 33.46L31.26 29.35C31.91 28.86 32.4401 27.8 32.4401 26.99V18.89C32.4501 17.76 31.59 16.52 30.54 16.12ZM27.48 21.72L23.18 26.02C23.03 26.17 22.84 26.24 22.65 26.24C22.46 26.24 22.27 26.17 22.12 26.02L20.52 24.4C20.23 24.11 20.23 23.63 20.52 23.34C20.81 23.05 21.29 23.05 21.58 23.34L22.66 24.42L26.43 20.65C26.72 20.36 27.2 20.36 27.49 20.65C27.78 20.94 27.78 21.43 27.48 21.72Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.c1f839ccc8deb29395aaa8edc99a225b.svg";
export { ForwardRef as ReactComponent };